export default __webpack_public_path__ + "static/media/logo-vertical.2be4e4a7.jpg";